import React from "react";

const UploadSignedLetterModal = ({
  isOpen,
  onClose,
  onUpload,
  formData,
  handleInputChange,
  handleFileChange,
  uploadText = "Upload",
  cancelText = "Cancel",
  className = "",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
      <div
        className={`bg-white p-4 lg:p-6 rounded-lg shadow-lg w-[85vw] sm:w-[80vw] md:w-2/3 lg:w-[30%] ${className}`}
      >
        <h2 className="text-xl text-center font-semibold pb-4">
          Upload Signed Letter
        </h2>

        <div className="mb-4">
          <input
            type="text"
            name="applicantName"
            placeholder="Applicant Name"
            value={formData.applicantName}
            onChange={handleInputChange}
            className="w-full p-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <input
            type="text"
            name="department"
            placeholder="Applicant Department"
            value={formData.department}
            onChange={handleInputChange}
            className="w-full p-2 border border-gray-300 rounded-md"
          />
        </div>

        <div className="mb-4">
          <select
            name="letterType"
            value={formData.letterType}
            onChange={handleInputChange}
            className="w-full p-2 border border-gray-300 rounded-md"
          >
            <option value="">Select Letter Type</option> {/* Default option */}
            <option value="Acceptance Letter">Acceptance Letter</option>
            <option value="Extension Letter">Extension Letter</option>
          </select>
        </div>

        <div className="mb-4">
          <input
            type="file"
            onChange={handleFileChange}
            className="w-full p-2 border border-gray-300 rounded-md"
          />
        </div>

        <div className="flex justify-center space-x-4 mt-6">
          <button
            className="bg-red-500 rounded-[10px] text-sm lg:text-base py-2 px-8 lg:p-2 mb-4 lg:px-10 text-white"
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button
            className="bg-green-700 rounded-[10px] text-sm lg:text-base py-2 px-8 lg:p-2 mb-4 lg:px-10 text-white"
            onClick={onUpload}
          >
            {uploadText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadSignedLetterModal;
